import React from 'react';
import AppRoutes from './routes';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Header from './components/common/Header';
import DiagnosticoProvider from './context/DiagnosticoContext/DiagnosticoProvider';
import CustomRouter from './context/sharedConfig/CustomRouter';
function App() {
  return (
    <CustomRouter>
      <DiagnosticoProvider>
        <ToastContainer position="bottom-left" />
        <Header />
        <AppRoutes />
      </DiagnosticoProvider>
    </CustomRouter>
  );
}

export default App;
